import React, { useCallback, useEffect } from "react";
import useDebounce from "react-use/lib/useDebounce";
import useKeyboardJs from "react-use/lib/useKeyboardJs";
import copy from "astrid-helpers/src/copyTextToClipboard";
import useTemp from "astrid-hooks/src/useTemp";
import Button from "../../Inputs/Button";
import Input from "../../Inputs/Input";
import Divider from "../../Layout/Divider";
import Flex from "../../Layout/Flex";
import Header from "../../Text/Header";
import Arrow from "../Icons/Arrow";
import Copy from "../Icons/Copy";
import ZoomIn from "../Icons/ZoomIn";
import ZoomOut from "../Icons/ZoomOut";
import { getPage, setPage, usePage } from "./state/page";
import { useNumPages } from "./state/pages";
import { setScale } from "./state/scale";
import { getSelection, useSelection } from "./state/selection";
function onClickUp() {
  setPage(getPage() - 1);
}
function onClickDown() {
  setPage(getPage() + 1);
}
function onZoomIn() {
  setScale(zoom => zoom * 1.1);
}
function onZoomOut() {
  setScale(zoom => zoom * 0.9);
}
function onCopy() {
  const selection = getSelection();
  if (selection) {
    copy(selection.text);
  }
}
export default function Toolbar() {
  const [page] = usePage();
  const pages = useNumPages();
  const selection = useSelection();
  const [tempPage, setTempPage] = useTemp(page);
  const [copying] = useKeyboardJs("command + c");
  const onChange = useCallback(event => setTempPage(parseInt(event.target.value || 0)), [setTempPage]);
  useDebounce(() => page !== tempPage && setPage(tempPage), 700, [page, tempPage]);
  useEffect(() => {
    if (copying) {
      onCopy();
    }
  }, [copying]);
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Flex, {
    padding: 8
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    disabled: page === 1,
    onClick: onClickUp
  }, /*#__PURE__*/React.createElement(Arrow, {
    style: {
      transform: "rotate(180deg)"
    }
  })), /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    disabled: page >= pages,
    onClick: onClickDown
  }, /*#__PURE__*/React.createElement(Arrow, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 10
    }
  }), /*#__PURE__*/React.createElement(Input, {
    inline: true,
    size: "small",
    value: tempPage,
    textSize: "large",
    style: {
      width: 50,
      textAlign: "center"
    },
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Header, {
    color: "default",
    style: {
      marginLeft: 10,
      fontSize: 16,
      fontWeight: 300
    }
  }, " / ", pages), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 15
    }
  })), /*#__PURE__*/React.createElement(Divider, {
    vertical: true
  }), /*#__PURE__*/React.createElement(Flex, {
    padding: 8
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: onZoomIn
  }, /*#__PURE__*/React.createElement(ZoomIn, null)), /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: onZoomOut
  }, /*#__PURE__*/React.createElement(ZoomOut, null))), /*#__PURE__*/React.createElement(Divider, {
    vertical: true
  }), /*#__PURE__*/React.createElement(Flex, {
    padding: 8
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    disabled: !selection,
    title: "Kopiera text",
    onClick: onCopy
  }, /*#__PURE__*/React.createElement(Copy, null))));
}
//# sourceMappingURL=Toolbar.js.map